import { API_DOMAIN } from '@constants';
import type { BucketType } from '@types';
import axios from '@utils/axios';

interface AliAuth {
  accessKeyId: string;
  accessKeySecret: string;
  securityToken: string;
  region: string;
  endpointO: string;
  bucketName: string;
}

const aliAuth = (bucket: BucketType) => {
  return axios.post<AliAuth>(`${API_DOMAIN}/aliyun/oss/auth`, { bucket });
};

export default aliAuth;
